import type {Schedule} from './data/types';

import useAppTheme from '../design_system/hooks/useAppTheme';
import Typography, {Size} from '../design_system/typography/Typography';
import Flex from '../layout/flex/Flex';

import {css} from '@emotion/react';
import {SerializedStyles} from '@emotion/serialize';
import {formatInTimeZone} from 'date-fns-tz';
import React from 'react';

export interface Props {
  readonly schedule: Schedule;
  readonly style?: boolean | SerializedStyles;
}

export default function DetailSchedule(props: Props): JSX.Element {
  const {schedule, style} = props;
  const {palettes, spacing} = useAppTheme();

  return (
    <div css={style}>
      <Typography
        size={Size.XL}
        variant="h2"
        weight={700}
      >
        {schedule.heading}
      </Typography>

      {schedule.items.map((item, i) => {
        return (
          <Flex
            key={i}
            sx={css({
              alignItems: 'flex-start',
              borderBottom: `2px solid ${palettes.background.neutral.disabled}`,
              paddingBlock: spacing.x8,
              paddingTop: spacing.x8,
            })}
          >
            <Typography
              css={css({
                flex: '0 0',
                flexBasis: '100px',
              })}
              size={Size.L}
              variant="div"
            >
              {formatInTimeZone(new Date(item.timeUTC * 1000), 'Asia/Tokyo', 'p')}
            </Typography>

            <div>
              <Typography
                size={Size.L}
                variant="div"
              >
                {item.description}
              </Typography>
              {item.info?.map((item, i) => {
                return (
                  <Typography
                    key={i}
                    size={Size.L}
                    variant="div"
                    weight={700}
                  >
                    {item}
                  </Typography>
                );
              })}
            </div>
          </Flex>
        );
      })}
    </div>
  );
}
